import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findResource = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource?`+params,
        method: 'GET'
    })
}

export const findResourceAll = () => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/all`,
        method: 'GET'
    })
}

export const findResourceDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/${id}`,
        method: 'GET'
    })
}

export const addResource = (data) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource`,
        method: 'POST',
        data: data
    })
}

export const editResource = (data) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource`,
        method: 'PUT',
        data: data
    })
}

export const delResource = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}

export const dsrmsUpdate = (data) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/dsrmsUpdate`,
        method: 'PUT',
        data: data
    })
}